"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var uuid_1 = require("../uuid/uuid");
var rect_1 = require("./rect");
var utils_1 = require("../utils");
var Pen = /** @class */function () {
  function Pen(json) {
    this.id = '';
    this.name = '';
    this.tags = [];
    this.rect = new rect_1.Rect(0, 0, 0, 0);
    this.lineWidth = 1;
    this.rotate = 0;
    this.offsetRotate = 0;
    this.globalAlpha = 1;
    this.dash = 0;
    this.strokeStyle = '';
    this.fillStyle = '';
    this.font = {
      color: '',
      fontFamily: '"Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial',
      fontSize: 12,
      lineHeight: 1.5,
      fontStyle: 'normal',
      fontWeight: 'normal',
      textAlign: 'center',
      textBaseline: 'middle',
      background: ''
    };
    // Date.getTime
    this.animateStart = 0;
    this.animateCycleIndex = 0;
    this.locked = false;
    if (json) {
      this.id = json.id || uuid_1.s8();
      this.name = json.name || '';
      this.tags = json.tags || [];
      if (json.rect) {
        this.rect = new rect_1.Rect(json.rect.x, json.rect.y, json.rect.width, json.rect.height);
      }
      this.dash = json.dash || 0;
      this.lineDash = json.lineDash;
      this.lineDashOffset = json.lineDashOffset || 0;
      this.lineWidth = json.lineWidth || 1;
      this.strokeStyle = json.strokeStyle || '';
      this.fillStyle = json.fillStyle || '';
      this.lineCap = json.lineCap;
      this.globalAlpha = json.globalAlpha || 1;
      this.rotate = json.rotate || 0;
      this.offsetRotate = json.offsetRotate || 0;
      if (json.font) {
        Object.assign(this.font, json.font);
      }
      this.text = json.text;
      if (json.textMaxLine) {
        this.textMaxLine = +json.textMaxLine || 0;
      }
      this.textOffsetX = json.textOffsetX || 0;
      this.textOffsetY = json.textOffsetY || 0;
      this.animateType = json.animateType;
      this.animateCycle = json.animateCycle;
      this.nextAnimate = json.nextAnimate;
      this.animatePlay = json.animatePlay;
      this.locked = json.locked;
      this.link = json.link;
      this.markdown = json.markdown;
      this.tipId = json.tipId;
      this.title = json.title;
      if (typeof json.data === 'object') {
        this.data = JSON.parse(JSON.stringify(json.data));
      } else {
        this.data = json.data || '';
      }
    } else {
      this.id = uuid_1.s8();
      this.textOffsetX = 0;
      this.textOffsetY = 0;
    }
  }
  Pen.prototype.render = function (ctx) {
    ctx.save();
    if (this.rotate || this.offsetRotate) {
      ctx.translate(this.rect.center.x, this.rect.center.y);
      ctx.rotate((this.rotate + this.offsetRotate) * Math.PI / 180);
      ctx.translate(-this.rect.center.x, -this.rect.center.y);
    }
    if (this.lineWidth > 1) {
      ctx.lineWidth = this.lineWidth;
    }
    ctx.strokeStyle = this.strokeStyle || '#222';
    ctx.fillStyle = this.fillStyle || 'transparent';
    if (this.lineCap) {
      ctx.lineCap = this.lineCap;
    }
    if (this.globalAlpha < 1) {
      ctx.globalAlpha = this.globalAlpha;
    }
    switch (this.dash) {
      case 1:
        ctx.setLineDash([5, 5]);
        break;
      case 2:
        ctx.setLineDash([10, 10]);
        break;
      case 3:
        ctx.setLineDash([10, 10, 2, 10]);
        break;
    }
    if (this.lineDash) {
      ctx.setLineDash(this.lineDash);
    }
    if (this.lineDashOffset) {
      ctx.lineDashOffset = this.lineDashOffset;
    }
    this.draw(ctx);
    ctx.restore();
    if (this.children) {
      for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
        var item = _a[_i];
        item.render(ctx);
      }
    }
  };
  Pen.prototype.hit = function (point, padding) {
    if (padding === void 0) {
      padding = 0;
    }
    if (!this.rotate) {
      return this.rect.hit(point, padding);
    }
    var pts = this.rect.toPoints();
    for (var _i = 0, pts_1 = pts; _i < pts_1.length; _i++) {
      var pt = pts_1[_i];
      pt.rotate(this.rotate, this.rect.center);
    }
    return utils_1.pointInRect(point, pts);
  };
  return Pen;
}();
exports.Pen = Pen;